import { updateCustomerById } from "../../../../app/api/updateCustomerById";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { showNotification } from "../../../../Services/notificationService";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";
import { INotificationPreferences } from "../../../../Orchestrator/Types/Interface/ICustomer";
import { invalidateUserCaches } from "../../../LogicActions/MyAccount/invalidateUserCaches";

interface SaveNotificationPreferencesParams {
    customerId: string;
    notificationPreferences: INotificationPreferences;
}

export class SaveNotificationPreferencesAction extends BaseAction<void, SaveNotificationPreferencesParams> {
    override async run(): Promise<void> {
        try {
            const { customerId, notificationPreferences } = this.params!;

            if (!customerId) {
                console.error("Customer ID not found.");
                showNotification("error", getTranslatedMessage("notificationPreferencesUpdateError", "Error updating notification preferences"), "");
                return;
            }

            const payload = {
                notificationPreferences: notificationPreferences
            };

            const userDetails = await updateCustomerById(customerId, payload);

            if (userDetails.status === "ok" && userDetails.answer) {
                updateRecoilState("userDataAtom", userDetails.answer);
                invalidateUserCaches();
                showNotification("success", getTranslatedMessage("notificationPreferencesUpdatedSuccessfully", "Notification preferences updated successfully."), "");
            } else {
                showNotification("error", getTranslatedMessage("notificationPreferencesUpdateFailed", "Failed to update notification preferences"), "");
            }
        } catch (error) {
            console.error("Error updating notification preferences:", error);
            showNotification("error", getTranslatedMessage("notificationPreferencesUpdateError", "Error updating notification preferences"), "");
        }
    }
}

export const saveNotificationPreferencesAction = new SaveNotificationPreferencesAction(); 